import { Model } from "react3l-common";
import { Field } from "react3l-decorators";
import { AppUserGrouping } from "models/AppUserGrouping";
import { Organization } from "models/Organization";
import { Province } from "models/Province";

export class ResponsibilityAppUserGroupingMappings extends Model {
  @Field(Number)
  public responsibilityId?: number;

  @Field(Number)
  public appUserGroupingId?: number;

  public appUserGrouping?: AppUserGrouping;

  public organizations?: Organization[];

  public provinces?: Province[];
}
